import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { PromotionClient } from '@medindex-webapi';
import { PageNavigationComponent } from '@shared/components/page-navigation/page-navigation.component';
import { PromotionComponent } from '@shared/modules/promotion/promotion.component';
import { SkeletonModule } from '@shared/modules/skeleton/skeleton.module';
import { BreadcrumbModule } from '@shared/modules/breadcrumb/breadcrumb.module';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { FormatLinkPipe } from '@shared/pipes/format-link/format-link.pipe';
import { BacktopComponent } from '@shared/components/backtop/backtop.component';
import { PromotionsRoutingModule } from './promotions-routing.module';
import { PromotionsSliderComponent } from './components/promotions-slider/promotions-slider.component';
import { AllPromotionsComponent } from './components/all-promotions/all-promotions.component';
import { PromotionSideBarComponent } from './components/promotion-side-bar/promotion-side-bar.component';
import { PromotionPageComponent } from './pages/promotion-page/promotion-page.component';
import { PromotionsComponent } from './pages/promotions/promotions.component';
import { PromotionMapComponent } from './components/promotion-map/promotion-map.component';

@NgModule({
  declarations: [
    PromotionsComponent,
    PromotionsSliderComponent,
    AllPromotionsComponent,
    PromotionSideBarComponent,
    PromotionPageComponent,
  ],
  imports: [
    CommonModule,
    BacktopComponent,
    PromotionsRoutingModule,
    CarouselModule,
    PageNavigationComponent,
    PromotionMapComponent,
    PromotionComponent,
    SkeletonModule,
    BreadcrumbModule,
    SafeHtmlPipe,
    FormatLinkPipe,
  ],
  providers: [PromotionClient],
})
export class PromotionsModule {}
